module.exports = __webpack_public_path__ + "img/vehicle-vespa.f5c59727.png";